
<div class="w-100">
  <mwp-card-content-header [url]="apiUrl" />
  @if (searchForm) {
    <div class="mb-3">
      <div class="content-container form-comp mb-3">
        <div class="title">
          <mwp-text-translate text="Search Fields" jsonKey="searchFields" />
        </div>
        <form [formGroup]="searchForm" class="row content">
          <div class="col-8 mb-3">
            <mwp-dropdown [form]="searchForm" labelName="Accounts" nameForControl="accountID" [data]="accounts" keyText="accountDescription" keyValue="accountID" />
          </div>
          <div class="col-4 mb-3">
            <mwp-dropdown [form]="searchForm" labelName="Date Range" nameForControl="dateRange" [data]="dateRangeTypes" [isListItemArray]="true" />
          </div>
        </form>
      </div>
      <div class="d-inline-flex justify-content-end w-100">
        <button class="mwp-button" [disabled]="searchForm.invalid" (click)="loadAccounts()">
          <mwp-text-translate text="Search" jsonKey="search" />
        </button>
      </div>
    </div>
  }
  <div class="content-container table-comp mb-3">
    <div class="title">
      {{ selectedAccountName }}
    </div>
    <div class="content">
      <table>
        <thead>
          <tr>
            <th class="ps-3 py-2">
              <mwp-text-translate text="Total Deposits:" jsonKey="totalDeposits" />
            </th>
            <th>
              <mwp-text-translate text="Total Payments:" jsonKey="totalPayments" />
            </th>
            <th>
              <mwp-text-translate text="Account Balance" jsonKey="accountBalance" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {{ accountDetail.totalDeposits | currency }}
            </td>
            <td>
              {{ accountDetail.totalPayments | currency }}
            </td>
            <td>
              {{ accountDetail.accountBalance | currency }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="content-container table-comp mb-3">
    <div class="title">
      <mwp-text-translate text="Transactions" jsonKey="transactions" />
      <span class="ms-1"> - {{ selectedDateRangeName }}</span>
    </div>
    <div class="content">
      <mwp-table [tableColumns]="accountDetailColumns" [dataSource]="accountDetailsMatTableData" />
    </div>
  </div>
</div>